import React from "react";

const INTERNAL_ROUTE_PATTERNS = [
  /^\/dashboard(?:\/|$)/,
  /^\/portal-(?:hubwork|guardian)(?:\/|$)/,
  /^\/p\/admin-/,
  /\/admin(?:\/|$)/,
  /^\/(?:login|register|esqueci-senha|redefinir-senha)(?:\/|$)/,
];

export default function InstitutionalFoundationFooter({ pathname = "/" }) {
  const isInternalRoute = INTERNAL_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));

  if (isInternalRoute) return null;

  return (
    <footer className="institutional-foundation-footer" aria-label="Informação institucional da Conceito">
      <span>Conceito Soluções Empresariais</span>
      <span className="institutional-foundation-footer__separator" aria-hidden="true">•</span>
      <span>Desde 2012</span>
    </footer>
  );
}
